<template>
  <el-dialog :visible.sync="shouldShow" @close="closeEvent" width="30%">
    <template slot="title">
      <p class="dialog-header-title">{{ title }}</p>
    </template>
    <div class="uploader">
      <div class="uploader_selector">
        <input type="file" accept=".csv" @change="choose" />
        <div v-if="!fileName">
          <p>Click here to select CSV file</p>
        </div>
        <div v-else class="selected">
          <p>{{ fileName }}</p>
          <span>Click to change</span>
        </div>
      </div>
      <div class="uploader_buttons">
        <el-button plain size="small" @click="shouldShow = false"
          >Cancel</el-button
        >
        <el-button
          type="primary"
          size="small"
          :loading="uploading"
          @click="upload"
          >Upload</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RaCsvUpload",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    uploading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileName: "",
      file: {}
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    },
    setUploading: {
      get() {
        return this.uploading;
      },
      set(value) {
        this.$emit("update:uploading", value);
      }
    }
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
      this.fileName = "";
      this.file = {};
    },
    choose(e) {
      if (!e) {
        return;
      }
      this.file = e.target.files[0];
      this.fileName = this.file.name;
    },
    upload() {
      this.setUploading = true;
      this.$emit("upload", this.file);
    }
  }
};
</script>

<style lang="scss">
.uploader {
  &_selector {
    height: 80px;
    border-radius: 8px;
    border: 1px dashed #798b8366;
    background: #f8faf9;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    input {
      position: absolute;
      height: 100%;
      width: 100%;
      cursor: pointer;
      opacity: 0;
      z-index: 1;

      &:focus {
        border: none;
      }
    }

    div {
      text-align: center;
      p {
        font-size: 0.75rem;
      }

      &.selected {
        p {
          font-size: 0.875rem;
          color: var(--ra-primary);
          font-weight: 500;
          line-height: 1.4;
        }

        span {
          font-size: 0.7rem;
          text-decoration: underline;
        }
      }
    }
  }

  &_buttons {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
